import React from 'react';

interface BuilderFieldProps {
  label: string;
  hint?: string;
  children: React.ReactNode;
}

export function BuilderField({ label, hint, children }: BuilderFieldProps) {
  return (
    <label className="block">
      <span className="sala-label mb-1.5 block">{label}</span>
      {hint && <p className="mb-2 text-xs text-[var(--sala-ink-dim)]">{hint}</p>}
      {children}
    </label>
  );
}

interface BuilderInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
}

export function BuilderInput({ label, hint, className, ...props }: BuilderInputProps) {
  return (
    <BuilderField label={label} hint={hint}>
      <input className={`sala-input-dark ${className ?? ''}`} {...props} />
    </BuilderField>
  );
}

interface BuilderTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  hint?: string;
}

export function BuilderTextarea({ label, hint, className, ...props }: BuilderTextareaProps) {
  return (
    <BuilderField label={label} hint={hint}>
      <textarea
        className={`sala-input-dark min-h-[88px] resize-y ${className ?? ''}`}
        {...props}
      />
    </BuilderField>
  );
}

interface BuilderSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: Array<{ value: string; label: string }>;
}

export function BuilderSelect({ label, options, className, ...props }: BuilderSelectProps) {
  return (
    <BuilderField label={label}>
      <select className={`sala-input-dark ${className ?? ''}`} {...props}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </BuilderField>
  );
}
